import { useEffect, useRef, useState } from 'react'
import KeepAlive from 'react-activation'
import { useLocation } from 'react-router-dom'
import {
  SActionBtn,
  SAside,
  SBack,
  SDrawer,
  SLowcodeList,
  STableActions,
} from 'shj-components'
import {
  getRegionLists,
  getAllCompany,
  dispatchMnrDelete,
  dispatchMnrFindResponseListByPage,
  dispatchMnrSaveOrUpdateEntity,
  httpCompanyList
} from "@/services/customerServices";
import { useSetState } from 'ahooks'
import {message} from 'antd'
import { config } from './config'
import { AddOrEditForm } from './addOrEdit'
const MaterialPackaging: React.FC = () => {
  const [state, setState] = useSetState({
    treeData: [], // 左侧树形结构数据
    companyList: [], // 门店
    regionList: [], // 门店
    provinceCode: null, // 当前选中分类code
    cityCode: null, // 当前选中分类code
    countyCode: null, // 当前选中分类code
  })
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [query, setQuery] = useState({})
  const [editData, setEditData] = useState({})

  const listRef = useRef<any>()
  //   右侧数据查询
  const fetchList = values => {
    const { current, pageSize, ...rest } = values
    return new Promise(async (resolve, reject) => {
      try {
        const data = await dispatchMnrFindResponseListByPage(current, pageSize, rest.query)
        resolve(data)
      } catch (err) {
        reject({ success: false })
      }
    })
  }
  //   右侧下拉选项加载
  const getOptions = async () => {
    const companyList: any = await httpCompanyList({})
    const regionList = await getRegionLists()
    console.log(regionList)
    setState({ companyList, regionList })
    return Promise.resolve({ companyList, regionList })
  }
  // 新增
  const onAdd = async () => {
    setEditData({})
    setDrawerVisible(true)
  }
  // 刷新
  const reloadFn = () => {
    listRef.current?.reload()
  }

  //  表格事件: 删除
  const onDel = id => {
    dispatchMnrDelete({id}).then(() => {
      message.success('操作成功')
      listRef.current?.reload()
    })
  }
  //  表格事件: 编辑
  const onEdit = (data) => {
    setEditData(data)
    setDrawerVisible(true)
  }
  //  抽屉事件: 保存
  const onSubmit = (val) => {
    dispatchMnrSaveOrUpdateEntity(val).then(()=>{
      setDrawerVisible(false)
      message.success('操作成功')
      reloadFn()
    })
  }
  // 右侧表格配置
  const extensions = {
    request: { fetchList, getOptions },
    events: {
      onAdd,
    },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
            <SActionBtn danger confirm title={'确认删除'} onClick={() => onDel(record.id)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }
  return (
    <div>
      <div>
        <SBack title="销售业务列表"></SBack>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      </div>
      {/* 新增弹出抽屉层 */}
      <SDrawer
        title={'新增销售业务'}
        width="60%"
        open={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        onSubmit={onSubmit}
        destroyOnClose
      >
        <AddOrEditForm editData={editData} />
      </SDrawer>
    </div>
  )
}

export default props => {
  const location = useLocation()
  return (
    <KeepAlive name={location.pathname} saveScrollPosition="screen" id={'keep' + location.pathname}>
      <MaterialPackaging {...props} />
    </KeepAlive>
  )
}
